import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TextBox from "../../../components/Common/TextBox";
import {
  emailValidation,
  nameValidation,
  phoneNumberValidation,
} from "../../../helpers/validations";
import {
  toTitleCase,
  setLocalStorage,
  getLocalStorage,
} from "../../../helpers/common";
import ProgressBar from "../../components/v2/ProgressBar";

const AddBuyerInfo = (props) => {
  const {
    handleFormValues,
    formValues,
    setUIKey,
    completedPercentage,
    onStepComplete,
    isEdit,
    isFromBuyerListingService,
  } = props;

  const [firstName, setFirstName] = useState(formValues?.clientFirstName || "");
  const [lastName, setLastName] = useState(formValues?.clientLastName || "");
  const [email, setEmail] = useState(formValues?.clientEmail || "");
  const [phoneNumber, setPhoneNumber] = useState(formValues?.clientPhone || "");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [disableSave, setDisableSave] = useState(true);

  useEffect(() => {
    if (
      firstName &&
      lastName &&
      email &&
      !firstNameError &&
      !lastNameError &&
      !emailError &&
      !phoneNumberError
    ) {
      setDisableSave(false);
    } else {
      setDisableSave(true);
    }
  }, [
    firstName,
    lastName,
    email,
    firstNameError,
    lastNameError,
    emailError,
    phoneNumberError,
  ]);

  const handleFirstName = (name) => {
    setFirstNameError("");
    setFirstName(name);
    if (name.trim() === "") {
      setFirstNameError("Enter First Name");
    } else if (!nameValidation(name.trim())) {
      setFirstNameError("Invalid input");
    }
  };

  const handleLastName = (name) => {
    setLastNameError("");
    setLastName(name);
    if (name.trim() === "") {
      setLastNameError("Enter Last Name");
    } else if (!nameValidation(name.trim())) {
      setLastNameError("Invalid input");
    }
  };

  const handleEmail = (email) => {
    setEmailError("");
    setEmail(email);
    if (email.trim() === "") {
      setEmailError("Enter Email Address");
    } else if (!emailValidation(email.trim())) {
      setEmailError("Invalid email format");
    }
  };

  const handlePhoneNumber = (phone) => {
    setPhoneNumberError("");
    setPhoneNumber(phone);
    if (phone.trim() !== "" && !phoneNumberValidation(phone.trim())) {
      setPhoneNumberError("Please enter valid phone number");
    }
  };

  return (
    <div className="gitcha-main-wrapper pb-102 bg-white">
      <div className="content-wrapper content-wrapper-h-102-percent">
        <ProgressBar
          completedPercentage={completedPercentage}
          setUIKey={setUIKey}
          isEdit={isEdit}
          isFromBuyerListingService={isFromBuyerListingService}
        />
        <div className="inner-layout-content-new h-100 bg-white">
          <div className="select-plan-wrap position-relative">
            <div className="location-header-wrap">
              <div className="layout-content-btm-sec position-static top-three-comp-shadow">
                <h6 className="">BUYER INFORMATION</h6>
                <h2 className="">Tell us about yourself</h2>
              </div>
            </div>

            <div className="location-conent-wrap p-3">
              <div className="wantad-location-wrap mb-3">
                <Row>
                  <Col xs={6}>
                    <div className="common-input-wrap mb-2">
                      <label className="form-label">
                        First Name<span>*</span>
                      </label>
                      <TextBox
                        id="fName"
                        name="firstName"
                        type="text"
                        maxLength={30}
                        value={toTitleCase(firstName)}
                        placeholder="First name"
                        className="form-control"
                        onChange={(e) => handleFirstName(e.target.value)}
                        errorClass="error-validation-msg"
                        errorMessage={firstNameError}
                      />
                    </div>
                  </Col>
                  <Col xs={6}>
                    <div className="common-input-wrap mb-2">
                      <label className="form-label">
                        Last Name<span>*</span>
                      </label>
                      <TextBox
                        id="lName"
                        name="lastName"
                        maxLength={30}
                        value={toTitleCase(lastName)}
                        type="text"
                        placeholder="Last name"
                        className="form-control"
                        errorClass="error-validation-msg"
                        onChange={(e) => handleLastName(e.target.value)}
                        errorMessage={lastNameError}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="wantad-location-wrap mb-3">
                <Row>
                  <Col md={12}>
                    <div className="common-input-wrap mb-2">
                      <label className="form-label">
                        Email<span>*</span>
                      </label>
                      <TextBox
                        id="email"
                        name="email"
                        type="email"
                        maxLength={30}
                        value={email}
                        placeholder="Email"
                        className="form-control"
                        onChange={(e) => handleEmail(e.target.value)}
                        errorClass="error-validation-msg"
                        errorMessage={emailError}
                      />
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="common-input-wrap mb-2">
                      <label className="form-label">Phone Number</label>
                      <TextBox
                        id="phoneNumber"
                        name="phoneNumber"
                        maxLength={30}
                        value={phoneNumber}
                        type="text"
                        placeholder="Phone Number"
                        className="form-control"
                        errorClass="error-validation-msg"
                        onChange={(e) => handlePhoneNumber(e.target.value)}
                        errorMessage={phoneNumberError}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="inner-layout-footer-new stack-index-100">
        <div className="inner-btm-fixed-nav">
          <div className="btn-wrap text-center pb-40 pt-0">
            <button
              type="button"
              className="btn btn-primary w-100 mb-0"
              disabled={disableSave}
              onClick={() => {
                onStepComplete();
                handleFormValues({
                  clientFirstName: firstName,
                  clientLastName: lastName,
                  clientEmail: email,
                  clientPhone: phoneNumber,
                });
                setUIKey(null);
              }}
            >
              {isEdit ? "Update" : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBuyerInfo;
